import PropTypes from 'prop-types';

/**
 * @memberof module:react/propTypes
 * @typedef {Array} FilterList
 * @prop {string} id Filter id
 * @prop {string} name Filter name
 */
export default PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string
}));



// WEBPACK FOOTER //
// ./app/propTypes/filterList.js